export default __webpack_public_path__ + "locales/ja-JP/EmptyTrashDialog.json?hash=c16b7a820d850e886812217167792276";